<atlas-navbar></atlas-navbar>
<router-outlet> </router-outlet>